import React from "react";
import { formatScore } from "../utils/format";

// Badge du Score Social — anneau de progression (jusqu'ici un simple rond plein cerclé d'un
// trait noir, le même partout : Accueil, Profil, page Score). Remplacé par un vrai anneau dont
// le remplissage reflète la note sur 10, façon jauge — un "badge travaillé", pas juste un cercle
// avec un chiffre dedans. Toujours strictement noir/blanc/gris (aucune couleur d'accent).
export default function ScoreBadge({ score, size = 80 }: { score?: number | string; size?: number }) {
  const s = Math.max(0, Math.min(10, Number(score) || 0));
  const pct = s / 10;
  const stroke = Math.round(size * 0.09);
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  return (
    <div style={{ position: "relative", width: size, height: size, flexShrink: 0 }}>
      <svg width={size} height={size} style={{ position: "absolute", inset: 0, transform: "rotate(-90deg)" }}>
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#EEEEEE" strokeWidth={stroke} />
        <circle
          cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#0a0a0a" strokeWidth={stroke}
          strokeLinecap="round" strokeDasharray={`${c * pct} ${c}`}
          style={{ transition: "stroke-dasharray .6s ease" }}
        />
      </svg>
      <div style={{ position: "absolute", inset: 0, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <span style={{ fontSize: size * 0.30, fontWeight: 800, color: "#0a0a0a", lineHeight: 1 }}>{formatScore(s)}</span>
        <span style={{ fontSize: Math.max(9, size * 0.11), fontWeight: 700, color: "#B0B0B0", letterSpacing: 0.5, marginTop: 2 }}>/10</span>
      </div>
    </div>
  );
}
